import { useContext, useState } from "react";
import Notification from "../../../../components/toast";
import reqBillingAsaas from "../../../../services/reqAsaas/reqBilling";
import { ContextContracting } from "../../context";

export const IndexHook = () => {
	const { custumerAsaas, setCustumerAsaas, handleNextStage } = useContext(ContextContracting);

	const [bankSlipUrl, setBankSlipUrl] = useState(null);
	const [loading, setLoading] = useState(false);

	const openBankSlipUrl = () => {
		window.open(bankSlipUrl, "_blank");
	};

	const nextStage = () => {
		handleNextStage();
	};

	const handleCreateBilling = async () => {
		try {
			setLoading(true);
			if (bankSlipUrl) {
				openBankSlipUrl();
				return;
			}

			if (custumerAsaas) {
				const bodyBilling = createBodyBilling(custumerAsaas);

				const responseAsaas = await reqBillingAsaas.insert(bodyBilling);

				if (responseAsaas?.data && typeof responseAsaas.data === "object") {
					const url = responseAsaas.data.bankSlipUrl;
					setBankSlipUrl(url);
					window.open(url, "_blank");
				} else {
					setBankSlipUrl({});
					Notification.showToast({
						message: "URL do boleto não disponível.",
						type: "warning",
					});
				}
			} else {
				Notification.showToast({
					message: "Cliente não encontrado.",
					type: "warning",
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const createBodyBilling = (idCustumer) => {
		return {
			ambiente: 1,
			customer: idCustumer,
			billingType: "UNDEFINED",
			description: "Fatura PDV",
			daysAfterDueDateToRegistrationCancellation: 15,
			externalReference: "",
			installmentCount: 0,
			installmentValue: 0,
			// value: 130,
			totalValue: 0,
			// dueDate: "2025-02-20",
			discountDueDateLimitDays: 0,
			discountType: "PERCENTAGE",
			discountValue: 0,
			interestValue: 0,
			fineValue: 0,
			fineType: "PERCENTAGE",
			postalService: false,
		};
	};

	return {
		handleCreateBilling,
		nextStage,
		loading,
	};
};
